import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import propag3m from "./components/propag-3m";
import propag30m from "./components/propag-30m";
import propag30mLower from "./components/propag-30m-lower";
import propag30mGreater from "./components/propag-30m-greater";

const principle: Slide = {
  description:
    "The difference between phase and group velocities is illustrated for phase velocity smaller than, equal to, and larger than group velocity. It is then proposed to see how a burst centred at 68 Hz is changed due to the dispersion, either of the Klein Gordon type (at 2 propagation distances and 3 cut-off frequencies fc) or in a tube of 2 mm-radius with visco-thermal losses for several propagation distances. Due to the dispersion, different frequency components of the burst propagate at different velocity, hence dispersing the burst profile.",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [1, 4],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "Klein Gordon dispersion",
                  scrollbars: false,
                  styles: {
                    fontWeight: 800,
                    lineHeight: "22px",
                    letterSpacing: "0.25em",
                    textTransform: "uppercase",
                  },
                },
              },
            },
          },
        ],
        [
          {
            variant: "layout",
            data: {
              type: "controlsToggleExtraContent",
              options: {
                controls: [
                  {
                    type: "button",
                    options: {},
                    items: [
                      { name: "propag. of 3 m ; f ≈ fc" },
                      { name: "propag. of 30 m ; f ≈ fc" },
                      { name: "propag. of 30 m ; f > fc" },
                      { name: "propag. of 30 m ; f < fc" },
                    ],
                  },
                ],
                controlsPosition: "bottom",
                extraContent: [[], [], [], []],
                components: [propag3m, propag30m, propag30mGreater, propag30mLower],
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
